import type { StatusKind } from '@erp/shared';
import { cn } from '@/lib/utils';

/**
 * Tiflux-style tinted status chip: bg + border + text trio, radius 4px, 22px.
 * Aberto = azul, Fechado = verde, Cancelado = vermelho (spec DESIGN-V2 — cores
 * de status fixas, fora dos tokens semânticos de propósito).
 *
 * Fonte ÚNICA das cores de status (spec 018): a lista tinha as cores trocadas
 * (aberto verde, fechado azul) e o mesmo ticket mudava de cor ao ser aberto.
 */
export const STATUS_KIND_CLASSES: Record<StatusKind, string> = {
  open: 'border-[#91CAFF] bg-[#E6F4FF] text-[#1677FF]',
  closed: 'border-[#B7EB8F] bg-[#F6FFED] text-[#52C41A]',
  canceled: 'border-[#FFA39E] bg-[#FFF1F0] text-[#FF4D4F]',
  custom: 'border-border bg-muted text-muted-foreground',
};

export function TicketStatusChip({
  kind,
  name,
  className,
}: {
  kind: StatusKind;
  name: string;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex h-[22px] shrink-0 items-center rounded-[4px] border px-2 text-xs font-medium whitespace-nowrap',
        STATUS_KIND_CLASSES[kind],
        className
      )}
    >
      {name}
    </span>
  );
}

/** Solid teal fully-rounded duration pill (apontamentos), white 12px text. */
export function DurationPill({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full bg-primary px-2 py-0.5 text-xs font-medium text-primary-foreground tabular-nums',
        className
      )}
    >
      {children}
    </span>
  );
}
